import ModelUtil from '@leverege/model-util';
import GeoLayerModel from "../../mapbox/renderers/GeoLayerModel.js";
const TYPE = 'molten.mapRenderer.HistoryModel';

/**
 * This represents geo layers that have point objects. It will contain
 * options for the layer as whole, such as visibility options and selection
 * and rollover options.
 */
function create(layerName, name, objectType) {
  return {
    ...GeoLayerModel.create(layerName, name, objectType),
    rolloverable: true,
    selectable: false,
    type: TYPE,
    symbolizer: null,
    queryOptions: {
      perPage: 1000,
      range: 'last7Days',
      accumulator: null
    },
    lineStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#4a525a'
      },
      // Colorizer,
      width: 2,
      style: 'long-dash',
      pattern: null,
      opacity: 0.8,
      cap: 'round',
      join: 'round'
    },
    selectedLineStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#181E25'
      },
      // Colorizer,
      width: 2,
      style: 'dot',
      pattern: null,
      opacity: 1,
      cap: 'round',
      join: 'round'
    },
    iconSize: {
      override: false,
      size: null,
      sizeUnits: 'pixels'
    },
    rolloverLineStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#181E25'
      },
      // Colorizer,
      width: 2,
      style: 'short-dash',
      pattern: null,
      opacity: 1,
      cap: 'round',
      join: 'round'
    },
    // TODO: Add Text options
    scale: {
      normal: 0.5,
      alert: 0.5,
      rollover: 0.5,
      selected: 0.5,
      scaleWithZoom: false,
      scaleFromZoom: 5,
      scaleToZoom: 10,
      scaleToFactor: 1,
      scaleFromFactor: 0
    }
  };
}
export default {
  ...GeoLayerModel,
  TYPE,
  create,
  ...ModelUtil.createAllValue('needsDate', null, null, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('needsCondition', null, null, {
    defaultValue: false
  }),
  ...ModelUtil.createAllValue('needsOrder', null, null, {
    defaultValue: false
  }),
  ...ModelUtil.createAllValue('queryOptions/perPage', 'perPage'),
  ...ModelUtil.createAllValue('queryOptions/range', 'range'),
  ...ModelUtil.createAllValue('queryOptions/accumulator', 'accumulator'),
  ...ModelUtil.createAllValue('queryOptions/condition', 'condition'),
  ...ModelUtil.createAllValue('lineStyle/color', 'LineColor'),
  ...ModelUtil.createAllValue('lineStyle/width', 'LineWidth'),
  ...ModelUtil.createAllValue('lineStyle/style', 'LineStyle'),
  ...ModelUtil.createAllValue('lineStyle/pattern', 'LinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('lineStyle/opacity', 'LineOpacity'),
  ...ModelUtil.createAllValue('lineStyle/cap', 'LineCap'),
  ...ModelUtil.createAllValue('lineStyle/join', 'LineJoin'),
  ...ModelUtil.createAllValue('iconSize/override', 'HasOverrideIconSize'),
  ...ModelUtil.createAllValue('iconSize/size', 'OverrideIconSize'),
  ...ModelUtil.createAllValue('iconSize/sizeUnits', 'OverrideIconSizeUnits'),
  ...ModelUtil.createAllValue('selectedLineStyle/color', 'SelectedLineColor'),
  ...ModelUtil.createAllValue('selectedLineStyle/width', 'SelectedLineWidth'),
  ...ModelUtil.createAllValue('selectedLineStyle/style', 'SelectedLineStyle'),
  ...ModelUtil.createAllValue('selectedLineStyle/pattern', 'SelectedLinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('selectedLineStyle/opacity', 'SelectedLineOpacity'),
  ...ModelUtil.createAllValue('selectedLineStyle/cap', 'SelectedLineCap'),
  ...ModelUtil.createAllValue('selectedLineStyle/join', 'SelectedLineJoin'),
  ...ModelUtil.createAllValue('rolloverLineStyle/color', 'RolloverLineColor'),
  ...ModelUtil.createAllValue('rolloverLineStyle/width', 'RolloverLineWidth'),
  ...ModelUtil.createAllValue('rolloverLineStyle/style', 'RolloverLineStyle'),
  ...ModelUtil.createAllValue('rolloverLineStyle/pattern', 'RolloverLinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('rolloverLineStyle/opacity', 'RolloverLineOpacity'),
  ...ModelUtil.createAllValue('rolloverLineStyle/cap', 'RolloverLineCap'),
  ...ModelUtil.createAllValue('rolloverLineStyle/join', 'RolloverLineJoin'),
  ...ModelUtil.createAllValue('scale/normal', 'NormalScale'),
  ...ModelUtil.createAllValue('scale/alert', 'AlertScale'),
  ...ModelUtil.createAllValue('scale/rollover', 'RolloverScale'),
  ...ModelUtil.createAllValue('scale/selected', 'SelectedScale'),
  ...ModelUtil.createAllValue('scale/scaleWithZoom', 'ScalesWithZoom'),
  ...ModelUtil.createAllValue('scale/scaleFromZoom', 'ScaleFromZoom'),
  ...ModelUtil.createAllValue('scale/scaleToZoom', 'ScaleToZoom'),
  ...ModelUtil.createAllValue('scale/scaleToFactor', 'ScaleToFactor'),
  ...ModelUtil.createAllValue('scale/scaleFromFactor', 'ScaleFromFactor'),
  ...ModelUtil.createAllValue('symbolizer')
};